<script>
	import "mini.css/dist/mini-default.min.css"
	import { Router, Link, Route, link} from "svelte-routing";
	import PngGrid from "./PngGrid.svelte";
	import Home from "./Home.svelte";
	export let url = "";
</script>

<Router url={url}>
	<header>
		<a class="button" use:link href="/">Home</a>
		<a class="button" use:link href="/pnggrid">Png grid generator</a>
	</header>
	<div class="container">
		<Route path="/pnggrid" component="{PngGrid}" />
		<Route path="/" component="{Home}" />
	</div>
</Router>

<style>
</style>
